import styled from '@emotion/styled';

import { blockingColors, blockingMetrics } from '../tokens';

export const TagRoot = styled('span')`
  box-sizing: border-box;
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
  width: 128px;
  min-width: 128px;
  max-width: 256px;
  height: 28px;
  padding: 8px 12px;
  background: ${blockingColors.alertBg};
  border: 1px solid ${blockingColors.alertIcon};
  border-radius: ${blockingMetrics.radiusPill};
`;

export const TagIcon = styled('span')`
  flex-shrink: 0;
  display: inline-flex;
  width: 12px;
  height: 12px;
  color: ${blockingColors.tagText};

  svg {
    width: 12px;
    height: 12px;
  }
`;

export const TagLabel = styled('span')`
  font-family: 'Mangueira', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: right;
  color: ${blockingColors.tagText};
  white-space: nowrap;
`;
